/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectTextIcon24Solid = forwardRef('CommentRectTextIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4v2.04c0 1.229 1.396 1.936 2.387 1.21L12.818 19H18a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H6Zm.25 9.75A.75.75 0 0 1 7 12h6.5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75ZM7 8a.75.75 0 0 0 0 1.5h10A.75.75 0 0 0 17 8H7Z" })));
});
